import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (pw9404/models/pw9404.go)
// ============================================================

export interface QueryParams {
  sex?: number;           // 0=all, 1=male, 2=female (F901_14)
  birthFrom?: string;     // ISO date string or empty (F901_13)
  birthTo?: string;       // ISO date string or empty
  hireDateFrom?: string;  // ISO date string or empty (F901_31)
  hireDateTo?: string;    // ISO date string or empty
  deptFrom?: string;      // CHAR(4) (F901_32)
  deptTo?: string;        // CHAR(4)
  gradeFrom?: string;     // CHAR(4) (F901_37)
  gradeTo?: string;       // CHAR(4)
  sortBy?: string;        // "empNo" | "dept" | "title" | "seniority"
}

export interface EmployeeRow {
  emp_no: string;          // F901_01 CHAR(8)
  emp_name: string;        // F901_11 CHAR(12)
  birth_date: string;      // F901_13 DATE
  sex: number;             // F901_14 NUMERIC 1=male/2=female
  dept_code: string;       // F901_32 CHAR(4)
  dept_name: string;       // resolved from F106
  title_code: string;      // F901_33 CHAR(4)
  title_name: string;      // resolved from F902
  seniority_start: string; // F901_311 DATE (年資起算日)
  hire_date: string;       // F901_31 DATE
  resign_date: string;     // F901_34 DATE
  grade_code: string;      // F901_37 CHAR(4)
  emp_id: string;          // F901_16 (身分證)
  ext_tel: string;         // F901_17 (分機)
  emp_type: string;        // F901_39
  pos_code1: string;       // F901_54
  pos_code2: string;       // F901_55
  seniority: number;       // calculated from F901_311 (BR-C03 u_nz)
}

export interface QueryResult {
  data: EmployeeRow[];
  count: number;
  message?: string;
}

// ============================================================
// API client
// ============================================================

export const pw9404Api = {
  async query(params: QueryParams): Promise<QueryResult> {
    const res = await apiClient.post('/api/pw9404/query', params);
    return res.data;
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(
        `/api/pw9404/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`
      );
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
